/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li4Inputs */

const tr_mesafeli_s8_c_li4 = /** @type {(inputs: Mesafeli_S8_C_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform'u yürürlükteki mevzuata, genel ahlaka ve üçüncü kişi haklarına aykırı amaçlarla kullanmamak.`)
};

const en_mesafeli_s8_c_li4 = /** @type {(inputs: Mesafeli_S8_C_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not to use the Platform for purposes contrary to applicable legislation, public morals or the rights of third parties.`)
};

const de_mesafeli_s8_c_li4 = /** @type {(inputs: Mesafeli_S8_C_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform nicht zu Zwecken nutzen, die gegen geltendes Recht, die guten Sitten oder Rechte Dritter verstoßen.`)
};

const ru_mesafeli_s8_c_li4 = /** @type {(inputs: Mesafeli_S8_C_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не использовать Платформу в целях, противоречащих действующему законодательству, общественной морали или правам третьих лиц.`)
};

/**
* | output |
* | --- |
* | "Not to use the Platform for purposes contrary to applicable legislation, public morals or the rights of third parties." |
*
* @param {Mesafeli_S8_C_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li4 = /** @type {((inputs?: Mesafeli_S8_C_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li4(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li4(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li4(inputs)
	return tr_mesafeli_s8_c_li4(inputs)
});